import { useAuthStore } from '@/stores/auth.ts';

export class FeatureFlag {
  can(flag) {
    if (process.env.APP_ENV !== 'production' && !useAuthStore().previewModes?.feature_flags) {
      return true;
    }

    // remove this after feature flags are re-cached
    if (this.getAuthStore().user?.permissions?.feature_flags[flag]?.enabled) {
      return true;
    } else if (this.getAuthStore().user?.permissions?.feature_flags[btoa(flag)]?.enabled) {
      return true;
    }

    return false;
  }

  getAuthStore() {
    return useAuthStore();
  }
}

export const featureFlagService = new FeatureFlag();
